/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveFineTuningJobRequest = {
  fineTuningJobId: string;
};

/** @internal */
export const RetrieveFineTuningJobRequest$inboundSchema: z.ZodType<
  RetrieveFineTuningJobRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  fine_tuning_job_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "fine_tuning_job_id": "fineTuningJobId",
  });
});
/** @internal */
export type RetrieveFineTuningJobRequest$Outbound = {
  fine_tuning_job_id: string;
};

/** @internal */
export const RetrieveFineTuningJobRequest$outboundSchema: z.ZodType<
  RetrieveFineTuningJobRequest$Outbound,
  z.ZodTypeDef,
  RetrieveFineTuningJobRequest
> = z.object({
  fineTuningJobId: z.string(),
}).transform((v) => {
  return remap$(v, {
    fineTuningJobId: "fine_tuning_job_id",
  });
});

export function retrieveFineTuningJobRequestToJSON(
  retrieveFineTuningJobRequest: RetrieveFineTuningJobRequest,
): string {
  return JSON.stringify(
    RetrieveFineTuningJobRequest$outboundSchema.parse(
      retrieveFineTuningJobRequest,
    ),
  );
}
export function retrieveFineTuningJobRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveFineTuningJobRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveFineTuningJobRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveFineTuningJobRequest' from JSON`,
  );
}
